export default __webpack_public_path__ + "static/media/popup_bsr.52481831.png";